import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { ClosingDateNotice } from './ClosingDateNotice';

export const ClosingDateConfirmedBanner = () => (
    <ClosingDateNotice
        tone="success"
        icon={faCheck}
        emphasised
        className="closing-date-confirmed-banner">
        <div className="closing-date-notice__title">
            Closing date confirmed by all parties
        </div>
        <div className="closing-date-notice__subtitle">
            Buyer and Seller have both accepted this date. It is now the
            official closing date for this engagement.
        </div>
    </ClosingDateNotice>
);
